/**
 * @generated SignedSource<<49bbd6fc49411fc5878298afeb122b67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type interiorsPhotosTracking_searchBrowsePhoto$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_searchBrowsePhoto">;
  readonly " $fragmentType": "interiorsPhotosTracking_searchBrowsePhoto";
};
export type interiorsPhotosTracking_searchBrowsePhoto$key = {
  readonly " $data"?: interiorsPhotosTracking_searchBrowsePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"interiorsPhotosTracking_searchBrowsePhoto">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "interiorsPhotosTracking_searchBrowsePhoto"
};

(node as any).hash = "e8f1f7fe0a81ed673cee85eadf5fbdd6";

export default node;
